import { useMemo } from "react";
import { useOutletContext } from "react-router-dom";

import { BlueprintDeployment } from "types/generated";

import TemplateDeploymentOutputsEmpty from "./Empty";
import { getDeploymentOutputs } from "./helpers";
import TemplateDeploymentOutputsTable from "./Table";

type TemplateDeploymentOutputsProps = {
  deployment: BlueprintDeployment;
};

const TemplateDeploymentOutputs = () => {
  const { deployment } = useOutletContext<TemplateDeploymentOutputsProps>();
  const outputs = useMemo(() => getDeploymentOutputs(deployment), [deployment]);

  if (outputs.length === 0) {
    return <TemplateDeploymentOutputsEmpty />;
  }

  return <TemplateDeploymentOutputsTable outputs={outputs} />;
};

export default TemplateDeploymentOutputs;
